import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export interface ChewyCircleLogoProps extends SvgIconProps {
  readonly linked?: boolean
}

const ChewyCircleLogo = forwardRef<SVGSVGElement, ChewyCircleLogoProps>(
  ({ linked = false, ...rest }, ref) => {
    const circleColor = linked ? '#1C49C2' : '#949494'
    return (
      <SvgIcon
        height="16px"
        ref={ref}
        viewBox="0 0 16 16"
        width="16px"
        {...rest}
      >
        <circle cx="8" cy="8" fill={circleColor} r="8" />
        <path
          d="M8.31311784,5.34961093 C7.22780688,5.59605015 6.95078695,6.82824621 5.79716971,7.05294078 C4.48796593,7.31025231 3.66070094,6.33536778 3.41024456,5.16478152 C3.20153092,4.20439342 3.37988622,2.78374384 4.83329215,2.57716979 C6.10834278,2.39234038 6.40813147,3.66440161 7.82738426,3.39621776 C8.66982843,3.2367571 9.07587134,2.60616264 8.87854208,1.79798699 C8.56736901,0.573039139 6.53335966,-0.325739165 4.30202105,0.112777669 C1.42936233,0.674514109 -0.513571973,3.1207857 0.120158551,6.19040354 C0.772863043,9.36149635 3.91115731,10.3907425 6.3929523,9.8724953 C9.58816847,9.20565979 10.1460031,7.04569257 9.97144262,6.33174368 C9.82344567,5.71202154 9.1631516,5.14666099 8.31311784,5.34961093 Z"
          fill="white"
          fillRule="nonzero"
          transform="translate(3.000000, 3.000000)"
        />
      </SvgIcon>
    )
  },
)

export default ChewyCircleLogo
